module.exports = __webpack_public_path__ + "static/media/reactlogo.cd7bb6be.png";